<template>
  <div class="monitorRecord">
    <!-- 导航栏 -->
    <nav-header
      id="m-header"
      head-title="历史记录"
      right-title="筛选"
      :showRightTile="true"
      @rightClick="openFilter"
    ></nav-header>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="depteDatalist.length > 0 ? '没有更多了' : ''"
        @load="onLoad"
        :immediate-check="false"
      >
        <div class="container">
          <div
            class="record-list"
            v-if="depteDatalist.length > 0 || finished == false"
          >
            <van-swipe-cell v-for="(item, index) in depteDatalist" :key="index">
              <div class="record-card" @click="goRecordDetail(item)">
                <div class="main-container">
                  <div class="row-dept d-flex">
                    <span class="dept-icon m-icon">{{ item.wardName }}</span>
                    <span class="unit-icon m-icon">{{ item.deptName }}</span>
                    <span class="question">{{ item.superStateName }}</span>
                  </div>
                  <div class="row-rate">
                    依从率{{ item.complianceRate }}%正确率{{
                      item.correctRate
                    }}%
                  </div>
                  <div class="row-others d-flex">
                    <span class="user info">{{ item.userName }}</span>
                    <span class="type info">{{ item.checkTypeName }}</span>
                    <span class="count info"
                      >含医疗{{$route.query.indexCode == 1 ? '和护理' : ''}}{{ item.activityTimers }}个时机</span
                    >
                    <span class="mutipart" v-if="item.hasFile">附件</span>
                    <img
                      src="../../assets/images/monitorRecord/i-record-right.png"
                      alt=""
                      class="status-img"
                    />
                    <span class="status-text">已上传</span>
                  </div>
                </div>
                <div class="foot-box d-flex">
                  <span class="question-type">{{ item.taskTypeName }}</span>
                  <span class="time">{{ item.taskTime }}</span>
                </div>
              </div>
              <template #right>
                <van-button
                  square
                  type="danger"
                  text="删除"
                  @click="testDelteBtn(item, index)"
                />
              </template>
            </van-swipe-cell>
          </div>
          <empty-component v-else />
        </div>
      </van-list>
    </van-pull-refresh>

    <!-- 筛选弹框 -->
    <van-popup
      v-model="filterShow"
      position="right"
      :style="{ height: '100%', width: '100%' }"
      duration="0.2"
    >
      <div class="popup-container">
        <!-- 头部 -->
        <nav-header
          @back="closeFilter"
          :isForbidBack="true"
          head-title="筛选条件"
          :zIndex="9999"
        ></nav-header>
        <!-- 选项 -->
        <div class="operator-list">
          <div
            class="operator-item"
            v-for="(item, index) in filterDataList"
            :key="index"
          >
            <template v-if="item.list && item.list.length > 0">
              <div class="title">{{ item.title }}</div>
              <div class="btn-group d-flex">
                <div
                  class="btn"
                  v-for="(item2, index2) in item.list"
                  :key="index2"
                  :class="{ active: item.activeIndex === index2 }"
                  @click="changeBtnChecked(index, index2)"
                >
                  {{ item2.text }}
                </div>
              </div>
            </template>
          </div>
        </div>
        <!-- 底部操作按钮 -->
        <div class="submit-group d-flex">
          <div class="reset-btn btn" @click="resetFilter">重置</div>
          <div class="comfirm-btn btn" @click="confirmFilter">确定</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import navHeader from "../../components/header/fixed-header.vue";
import Vue from "vue";
import { mapState } from "vuex";
import emptyComponent from "../../components/empty-component/empty-component.vue";
import { SwipeCell, Dialog } from "vant";
Vue.use(SwipeCell);

export default {
  components: {
    navHeader,
    emptyComponent,
  },
  computed: {
    ...mapState({
      _userInfo: (state) => state.InvestorInfo,
      baseUrl: (state) => state._base,
    }),
  },
  data() {
    return {
      strss: "",
      pageInfo: {
        page: 1,
        rows: 10,
      },
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      filterShow: false,
      filterCondition: {
        deptIds: '',
        checkTypeIds: ''
      },
      depteDatalist: [],
      filterDataList: [
        {
          title: "标准科室",
          activeIndex: 0,
          list: [],
        },
        // {
        //   title: "上传状态",
        //   activeIndex: 0,
        //   list: [
        //     {
        //       text: "全部",
        //       value: "",
        //     },
        //     {
        //       text: "未上传",
        //       value: "1",
        //     },
        //     {
        //       text: "待上传",
        //       value: "2",
        //     },
        //     {
        //       text: "上传失败",
        //       value: "3",
        //     },
        //     {
        //       text: "已上传",
        //       value: "4",
        //     },
        //   ],
        // },
        {
          title: "督查类型",
          activeIndex: 0,
          list: [
            {
              text: "全部",
              value: "",
            },
            {
              text: "抽查",
              value: "10",
            },
            {
              text: "自查",
              value: "20",
            },
            {
              text: "暗访",
              value: "30",
            },
          ],
        },
      ],
    };
  },
  created() {
    this.initHistoryData();
    this.searchStandardDeptList();
  },
  mounted() {},
  methods: {
    // 去手卫生历史记录详情
    goRecordDetail(item) {
      let entryId = 'WhoResult'
      if(this.$route.query.indexCode == 2){
        entryId = `SurgicalHandDisinfection&toolsCode=WKSXD&entryComId=${this._userInfo.data.comId}`
      }
      let path =  `${this.baseUrl}/gk2018/?entryId=${entryId}&source=1&superState=${item.superState}&entryUserId=${this._userInfo.data.userId}&entryTaskId=${item.id}&toolsId=${item.toolsId}&isIframeBack=1`
      console.log(path,'去手卫生历史记录详情');
      // location.href = 'http://192.168.1.21:8081/gk2018/?entryId=WhoResult&source=1&superState=null&entryUserId=393951&entryTaskId=1197880&isIframeBack=1&toolsId=400340'
      location.href = path
      return
      localStorage.setItem('recordDetail',JSON.stringify(item))
      this.$router.replace('/recordDetail')
    },
    // 删除手卫生历史记录
    deleteTask(item, index) {
      let params = {
        userId: this._userInfo.data.userId,
        comId: this._userInfo.data.comId,
        data: { 
          id: item.id,
          isYcx: this.$route.query.indexCode == 2 ? '1' : ''
        }
      };
      this.$http.deleteTask(params).then((res) => {
        if (res.code == 0) {
          this.depteDatalist.splice(index, 1);
          this.$toast(res.msg);
        } else {
          this.$toast(res.msg);
        }
      });
    },
    // 获取历史记录
    initHistoryData(deptIds = "", checkTypeIds = "") {
      let params = {
        userId: this._userInfo.data.userId,
        comId: this._userInfo.data.comId,
        data: {
          comId: this._userInfo.data.comId,
          userId: this._userInfo.data.userId,
          taskId: this.$route.query.taskId,
          taskLinkId: this.$route.query.taskLinkId,
          isPdcaVersion: {},
          page: this.pageInfo.page,
          rows: this.pageInfo.rows,
          deptIds: deptIds + "",
          checkTypeIds: checkTypeIds,
        },
      };
      let url = `/incontrol-intf/api/reportingTaskHand/searchHandHigieneHistory`
      if(this.$route.query.indexCode == 2){ // 1手卫生  2外科手消毒
        url = `/incontrol-intf/api/reportingTaskHand/listSurgicalHistory`
      }
      this.$http.searchHistory(url,params).then((res) => {
        if (res.code == 0) {
          let resArr = res.data.rows ? res.data.rows : [];
          // 刷新
          if (this.refreshing || this.pageInfo.page == 1) {
            this.depteDatalist = [...resArr];
            this.refreshing = false;
          } else {
            // 加载
            this.depteDatalist = [...this.depteDatalist, ...resArr];
          }
          setTimeout(() => {
            // 结束加载状态
            this.loading = false;
            // 没有更多了
            if (resArr.length < 10) {
              this.finished = true;
            }
          }, 100);
          // 空数据
          if (this.depteDatalist.length === 0) {
            this.$toast("暂无数据");
          }
        } else {
          this.refreshing = false;
          this.loading = false;
          this.finished = true;
          this.$toast(res.msg);
        }
      });
    },
    // 获取标准科室列表
    searchStandardDeptList() {
      let params = {
        userId: this._userInfo.data.userId,
        comId: this._userInfo.data.comId,
        data: {
          comId: this._userInfo.data.comId,
          userId: this._userInfo.data.userId,
          taskId: this.$route.query.taskId,
          indexCode: this.$route.query.indexCode
        },
      };
      this.$http.searchStandardDeptList(params).then((res) => {
        if (res.code == 0) {
          let arr = res.data ? res.data : [];
          arr = arr.map((v) => {
            return {
              text: v.deptName,
              value: v.deptId,
            };
          });
          let obj = {
            text: "全部",
            value: "",
          };
          arr.unshift(obj);
          this.filterDataList[0].list = arr;
        } else {
          this.$toast(res.msg);
        }
      });
    },
    testDelteBtn(item, index) {
      if(this.$route.query.reportStatus === '1') {
        this.$toast('已上报，不可删除！')
        return
      }
      if(this.$route.query.stepIsEnd == '1') {
        this.$toast('活动已结束，不可删除！')
        return
      }

      Dialog.confirm({
        message: "确定删除吗？",
      })
        .then(() => {
          this.deleteTask(item, index);
        })
        .catch(() => {
          console.log("取消");
        });
    },
    beforeSwipeCellClose(event) {},
    // 改变选中
    changeBtnChecked(index1, index2) {
      this.filterDataList[index1].activeIndex = index2;

      return;
      let index = this.filterDataList[index1].activeIndex.findIndex(
        (v) => v === index2
      );
      if (index === -1) {
        this.filterDataList[index1].activeIndex.push(index2);
      } else {
        this.filterDataList[index1].activeIndex.splice(index, 1);
      }
      console.log(this.filterDataList[index1].activeIndex, "7676");
    },
    // 判断是否选中
    isfilterSelected(index1, index2) {
      console.log(this.filterDataList[index1].activeIndex, "45545");
      let index = this.filterDataList[index1].activeIndex.findIndex(
        (v) => v === index2
      );
      return index !== -1;
    },
    // 打开筛选
    openFilter() {
      this.filterShow = true;
    },
    // 重置
    resetFilter() {
      this.filterDataList.forEach((v) => (v.activeIndex = 0));
      this.filterCondition.deptIds = deptIds
      this.filterCondition.checkTypeIds = checkTypeIds
    },
    // 筛选确定
    confirmFilter() {
      let deptIds =
        this.filterDataList[0].list[this.filterDataList[0].activeIndex].value;
      let checkTypeIds =
        this.filterDataList[1].list[this.filterDataList[1].activeIndex].value;
      scrollTo(0, 0);
      this.filterCondition.deptIds = deptIds
      this.filterCondition.checkTypeIds = checkTypeIds
      //  return
      this.pageInfo.page = 1;
      // 清空列表数据
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.initHistoryData(deptIds, checkTypeIds);
      this.closeFilter();
    },
    // 关闭筛选
    closeFilter() {
      this.filterShow = false;
    },
    onLoad() {
      if (this.refreshing) {
        // 刷新
        this.pageInfo.page = 1;
        this.finished = false;
        this.initHistoryData(this.filterCondition.deptIds,this.filterCondition.checkTypeIds);
      } else {
        // 加载
        this.pageInfo.page++;
        this.initHistoryData(this.filterCondition.deptIds,this.filterCondition.checkTypeIds);
      }
    },
    onRefresh() {
      this.pageInfo.page = 1;
      // 清空列表数据
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
  },
};
</script>

<style lang='scss' scoped>
.monitorRecord {
  //  #m-heade {
  //    background-color: pink;
  //  }
  background-color: #f2f2f2;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  font-size: 12px;
  font-family: PingFangSC, PingFangSC-Regular;
  .container {
    padding-bottom: 20px;
    // flex: 1;
    // overflow: scroll;
  }
  .goods-card {
    margin: 0;
    // background-color: @white;
  }

  /deep/ .van-dialog__cancel, .van-dialog__confirm  {
    border: 34!important;
  }
  /deep/ .van-button {
    height: 100%;
  }

  /deep/ .van-hairline--top::after {
    border-top-width: 10px!important;
  }
  .record-list {
    .record-card {
      width: 375px;
      margin-bottom: 10px;
      min-height: 148px;
      box-sizing: border-box;
      padding-left: 15px;
      background: #ffffff;
      .main-container {
        box-sizing: border-box;
        padding-right: 15px;
        padding-top: 15px;
        height: 108px;
        border-bottom: 1px solid #eee;
        font-family: PingFangSC, PingFangSC-Medium;
        .row-dept {
          align-items: center;
          .m-icon {
            padding: 2px 8px;
            border-radius: 11px;
            margin-right: 6px;
            font-size: 12px;
            font-weight: 500;
            // line-height: 17px;
            color: #ffffff;
          }
          .dept-icon {
            background: #26c6da;
          }
          .unit-icon {
            background: #7986cb;
          }
          .question {
            margin-left: auto;
            font-weight: 500;
            color: #26b4ff;
          }
        }
        .row-rate {
          margin: 11px 0 9px 0;
          font-size: 15px;
          font-weight: 500;
          text-align: left;
          color: #333333;
          line-height: 24px;
        }
        .row-others {
          align-items: center;
          .info {
            font-size: 12px;
            font-weight: 500;
            color: #999999;
            line-height: 17px;
          }
          .type {
            margin: 0 19px;
          }
          .count {
            margin-right: 10px;
          }
          .mutipart {
            padding: 1px 7px;
            background: #fff9ec;
            border-radius: 100px;
            font-size: 13px;
            font-weight: 500;
            color: #f98821;
            line-height: 18px;
          }
          .status-img {
            margin-left: auto;
            width: 12px;
            height: 12px;
            margin-right: 5px;
          }
          .status-text {
            font-size: 12px;
            font-family: PingFangSC, PingFangSC-Regular;
            font-weight: 400;
            color: #46b942;
            line-height: 17px;
          }
          .status-text-warning {
            color: #ff9c0f;
          }
          .status-text-error {
            color: #f05757;
          }
        }
      }
      .foot-box {
        align-items: center;
        height: 50px;
        font-family: PingFangSC, PingFangSC-Medium;
        box-sizing: border-box;
        padding-right: 15px;
        .question-type {
          font-size: 13px;
          font-weight: 500;
          color: #666;
        }
        .time {
          margin-left: auto;
          font-size: 12px;
          font-weight: 500;
          color: #999;
        }
      }
    }
  }
  .popup-container {
    width: 100%;
    height: 100%;
    // background-color: pink;
    .operator-list {
      box-sizing: border-box;
      .operator-item {
        box-sizing: border-box;
        padding: 14px 12px 4px;
        border-bottom: 1px solid #f2f2f2;
        .title {
          margin-bottom: 10px;
          font-size: 14px;
          color: #999999;
          line-height: 20px;
        }
        .btn-group {
          flex-shrink: 0;
          flex-wrap: wrap;
          .btn {
            margin-right: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 110px;
            height: 42px;
            background: #f2f2f2;
            margin-bottom: 10px;
            font-size: 16px;
            color: #333;
          }
          .btn:nth-child(3n + 3) {
            margin-right: 0;
          }
          .active {
            background: #26b4ff;
            color: #ffffff;
          }
        }
      }
      .operator-item:last-child {
        border-bottom: none;
      }
    }
    .submit-group {
      position: fixed;
      width: 100%;
      height: 49px;
      bottom: 0;
      .btn {
        display: flex;
        justify-content: center;
        align-items: center;
        flex: 1;
        font-size: 18px;
      }
      .reset-btn {
        background: #edf3ff;

        color: #26b4ff;
      }
      .comfirm-btn {
        background: #26b4ff;
        color: #ffffff;
      }
    }
  }
}
</style>